import React from 'react';
export default {
  'cart': {
    'change-currency': 'Cambiar moneda',
    'and-then': 'Y después',
    'plus-tax': ' + impuestos',
    'for': 'Por',
    'edit': {
      'label': 'Editar',
      'submit': 'Aplicar'
    },
    'empty': 'Aún no ha añadido nada a su pedido.',
    'free': 'gratis',
    'promo-code': {
      'add': 'Agregar tarjeta de regalo o código de promoción',
      'error': {
        'invalid-for-subscription': 'El código de cupón no es válido para este pedido.'
      },
      'label': 'Tarjeta de regalo o código de promoción',
      'submit': 'Aplicar'
    },
    'subtotal-line': {
      'tax-label': 'Impuestos estimados',
      'subtotal': 'Total Parcial',
      'tax': 'Impuesto',
      'gift-card': 'Tarjeta de regalo'
    },
    'starting-price': 'Precio inicial',
    'title': 'Resumen del pedido',
    'setup-fee': 'tarifa de apertura',
    'free-trial': 'Prueba gratis',
    'total-line': {
      'label': 'Total'
    },
    'order-total-line': {
      'label': 'Total del pedido'
    }
  },
  'address': {
    'country': 'País',
    'address2': 'Departamento, suite, etc.',
    'tax-identifier': 'Identificador fiscal',
    'tax-identifier-type': 'Tipo de identificador fiscal',
    'first-name': 'Nombre de pila',
    'last-name': 'Apellido',
    'company-name': 'Nombre de Empresa',
    'address1': 'Dirección',
    'city': 'Ciudad',
    'state': 'Estado',
    'postal-code': 'Código postal',
    'phone-number': 'Número de teléfono',
    'vat-number': 'Número IVA/ID Fiscal'
  },
  'payment-method': {
    'credit-card': {
      'label': 'Datos de la tarjeta',
      'expiry': 'MM/AA',
      'name': 'Tarjeta De Crédito',
      'number': 'Número de tarjeta',
      'cvv': 'CVV',
      'brand': {
        'visa': 'Visa',
        'master': 'MasterCard',
        'cartes_bancaires': 'Cartes Bancaires'
      }
    },
    'ach': {
      'name': 'Cuenta Bancaria',
      'routing-number': 'Número de ruta',
      'account-number': 'Número De Cuenta',
      'account-number-confirmation': 'Confirmar Número de cuenta',
      'account-type': {
        'label': 'Tipo De Cuenta',
        'checking': 'Cuenta de cheques',
        'savings': 'Cuenta de ahorros'
      },
      'name-on-account': 'Nombre en la cuenta'
    },
    'amazon': {
      'name': 'Amazon'
    },
    'apple-pay': {
      'name': 'Apple Pay'
    },
    'boleto': {
      'name': 'Boleto'
    },
    'bacs': {
      'name': 'Bacs',
      'sort-code': 'Código Sort'
    },
    'becs': {
      'name': 'BECS',
      'bsb-code': 'Código BSB'
    },
    'google-pay': {
      'name': 'Google Pay'
    },
    'ideal': {
      'name': 'Ideal'
    },
    'paypal': {
      'name': 'PayPal'
    },
    'qiwi_wallet': {
      'name': 'Qiwi Wallet'
    },
    'sepa': {
      'name': 'SEPA',
      'iban': 'IBAN'
    },
    'sofort': {
      'name': 'Sofort'
    },
    'venmo': {
      'name': 'Venmo'
    }
  },
  'billing-address': 'Dirección de facturación',
  'billing-address-same-as-shipping': 'La misma que la dirección de envío',
  'submit': 'Pagar ahora',
  'payment-method-selected': ({ paymentMethod }: { paymentMethod: string }) => <>{paymentMethod} seleccionado</>,
  'express-checkout': 'Pago exprés',
  'change-payment-method': 'Cambiar método de pago',
  'day': 'día',
  'days': 'días',
  'week': 'semana',
  'weeks': 'semanas',
  'month': 'mes',
  'months': 'meses',
  'year': 'año',
  'years': 'años',
  'pluralize': {
    'days': ({ count }: { count: number }) => count === 1 ? 'día' : 'días',
    'weeks': ({ count }: { count: number }) => count === 1 ? 'semana' : 'semanas',
    'months': ({ count }: { count: number }) => count === 1 ? 'mes' : 'meses',
    'years': ({ count }: { count: number }) => count === 1 ? 'año' : 'años'
  },
  'confirmation': {
    'title': 'Gracias por su pedido',
    'order-num': ({ number }: { number: number }) => <>Pedido #{number}</>,
    'fulfilled-on': ({ date }: { date: string }) => <>Completado el {date}</>,
    'email-notice': 'Recibirá una confirmación por correo electrónico de su pedido.',
    'payment': 'Pago',
    'return-to': ({ name }: { name: string }) => <>Volver a {name}</>,
    'credit-applied': 'Crédito Aplicada'
  },
  'subscription': {
    'details': {
      'addons': {
        'flat.charge': ({ amount, addOnName }: { amount: string; addOnName: string }) => <>Se le cobrará {amount}/unidad por {addOnName}</>,
        'no-flat.charge': ({ amount, units, unitsLabel, addOnName }: { amount: string; units: number; unitsLabel: string; addOnName: string }) => <>Se le cobrará {amount} por {units} {unitsLabel} de {addOnName}</>
      },
      'billing.starting': ({ startDate, amount, intervalLengthLabel, taxable = true }: { startDate: string; amount: string; intervalLengthLabel: string; taxable?: boolean }) => <>A partir de {startDate} se le cobrará {amount}/{intervalLengthLabel}{taxable ? ' + impuestos' : ''}</>,
      'billing.starting.setupfee': ({ startDate, amount, intervalLengthLabel, setupFee, taxable = true }: { startDate: string; amount: string; intervalLengthLabel: string; setupFee: string; taxable?: boolean }) => <>A partir de {startDate} se le cobrará {amount}/{intervalLengthLabel}{taxable ? ' + impuestos' : ''}, junto con una tarifa única de {setupFee}</>,
      'cancellation.reminder': 'Recibirá un recordatorio por correo electrónico {days} días antes de que comience la facturación.',
      'trial.start': ({ trialLength, trialInterval }: { trialLength: number; trialInterval: string }) => <>Su prueba gratuita de {trialLength} {trialInterval} comienza hoy.</>,
      'trial.ends': ({ trialEndsAt }: { trialEndsAt: string }) => <>Para evitar ser cobrado, debe cancelar antes de {trialEndsAt}.</>,
      'email.reminder': ({ days }: { days: number }) => <>Recibirá un recordatorio por correo electrónico {days} días antes de que comience la facturación.</>,
      'no-renewal': ({ billingEndsAt }: { billingEndsAt: string }) => <>Su suscripción finalizará el {billingEndsAt} y no se renovará automáticamente.</>,
      'ramp.after': ({ afterChargeTime, newChargeAmount }: { afterChargeTime: string; newChargeAmount: string }) => <>Después de {afterChargeTime}, se le cobrará {newChargeAmount} + impuestos</>,
      'renewal': ({ totalCyclesLengthLabel }: { totalCyclesLengthLabel: string }) => <>Su suscripción se renovará automáticamente cada {totalCyclesLengthLabel} y continuará hasta que la cancele.</>,
      'title': 'Detalles de la Suscripción',
    },
    'agreement.button': 'Aceptar y Continuar',
    'agreement.text': 'Al hacer clic en "Aceptar y Continuar", confirma que entiende y acepta estos términos de suscripción. No se aplicarán cargos hasta que complete el proceso de pago.',
    'changeOrCancel': 'Para cambiar o cancelar su suscripción ',
    'access-account': 'acceder a su cuenta',
    'contact-support': 'contactar con soporte',
  },
  'back': 'Regresar',
  'contact-info': 'Información de Contacto',
  'email-address': 'Correo electrónico',
  'payment-info': 'Datos de Facturación',
  'shipping-address': 'Dirección de envío',
  'legal': {
    'accept': 'Acepto ',
    'privacy-policy': 'Política de Privacidad',
    'terms-of-service': 'Condiciones del servicio'
  },
  'recurring': {
    'consent': `Acepto pagar los cargos anteriores, mostrados con una frecuencia de facturación, de forma recurrente,
                a menos que la suscripción se cancele antes de que finalice el periodo de facturación actual.`,
    'cancel': 'Para cancelar su suscripción, visite la página de Gestión de su cuenta.'
  },
  'support': {
    'array': {
      'wordsConnector': ', ',
      'twoWordsConnector': ' y ',
      'lastWordConnector': ', y '
    }
  },
  'powered-by': ({ recurly }: { recurly: string }) => <>Suscripción de facturación potenciado por {recurly}</>,
  'errors': {},
  'subscribe': 'Suscribirse'
};
